import { Table } from 'react-bootstrap';

interface IProps {
    serologyTests: string[],
    requiresQfg: boolean
}

const Serology = (props: IProps) => {
    return (
        <Table bordered striped condensed className='table-nkr-styled'>
            <thead>
                <tr >
                    <th colSpan={3} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>Serology Tests </span></th>
                </tr>
            </thead>
            <tbody>
                {props.serologyTests !== null && (
                    <>
                        {props.serologyTests.map((x, i) =>
                            <tr key={i}>
                                <td key={`name${i}`}>{`${i + 1}. ${x}`}</td>
                            </tr>
                        )}

                        {props.requiresQfg && props.serologyTests.length > 0 &&
                            <tr key={`${props.serologyTests.length + 1}`}>
                                <td key={`q${props.serologyTests.length + 1}`}>{`${props.serologyTests.length + 1}. QuantiFERON-TB Gold *This test is not ran by the NKR lab due to specimen handling requirements.`} </td>
                            </tr>
                        }
                    </>
                )}
            </tbody>
        </Table>
    );
}

export default Serology;